module.exports = __webpack_public_path__ + "static/media/Captain America 2.795df4be.jpg";